<template>
  <form class="create-feed-form" @submit.prevent="save">
    <div class="create-feed-form--first-row">
      <div class="create-feed-form--col-left">
        <label class="input-block mb-15">
          <div class="input-block--text">Название:</div>
          <input type="text" name="" v-model="form.name">
        </label>
        <label class="input-block mb-25">
          <div class="input-block--text">Статус:</div>
          <v-select v-model="form.status" :clearable="false" :options="statuses" :reduce="status => status.code"></v-select>
        </label>
        <label class="input-block mb-25">
          <div class="input-block--text">Разрешить трафик:</div>
          <v-select v-model="form.allowTrafficCategory" :clearable="false" :options="trafficCategories" :reduce="item => item.value"></v-select>
        </label>
        <label class="input-block mb-25">
          <div class="input-block--text">Фильтр прокси трафика:</div>
          <v-select v-model="form.proxyTrafficFilter" :clearable="false" :options="proxyTrafficFilterValues" :reduce="item => item.value"></v-select>
        </label>
        <label class="input-block mb-25">
          <div class="input-block--text">Ограничение по платформе:</div>
          <v-select v-model="form.deviceTypeFilter" :clearable="false" :options="deviceTypeFilterValues" :reduce="item => item.value"></v-select>
        </label>
        <RadioChoice class="mb-25" title="Тип:" group="type" :items="types" v-model="form.type" @change="setValue" />
        <div v-if="isEdit" class="input-block mb-25">
          <div class="input-block--text">Токен статистики:</div>
          <div class="copy-block" @click="copyMixin('#copy-code', 'Statistic token was copied ')">{{ form.token }}
            <div class="copy-block--icon">
              <svg class="svg-sprite-icon svg-sprite-unstyled icon-copy">
                <use xlink:href="@/assets/img/svg/symbol/symbol_unstyled.svg#copy"></use>
              </svg>
              <svg class="svg-sprite-icon svg-sprite-unstyled icon-check">
                <use xlink:href="@/assets/img/svg/symbol/symbol_unstyled.svg#check"></use>
              </svg>
            </div>
          </div>
          <input type="hidden" id="copy-code" :value="form.token">
        </div>

        <div class="create-feed-form-inputs mb-35">
          <label class="input-block">
            <div class="input-block--text">ID Парсера:</div>
            <v-select v-model="form.parser" :clearable="false" :options="parsers" :reduce="parser => parser.code"></v-select>
          </label>
          <label class="input-block">
            <div class="input-block--text">Ограничение RPS:</div>
            <input type="text" name="limitRps" v-model.number="form.rps">
            <div class="input-block--note">0 - без лимита</div>
          </label>
          <label class="input-block">
            <div class="input-block--text">Дискреп:</div>
            <input class="percent-input" type="text" name="discrep" v-model.number="form.discrep">
          </label>
        </div>

        <div class="mb-35" v-show="form.parser === 'custom' || form.parser === 'custom_with_context'">
          <label class="input-block">
            <div class="input-block--text">Схема парсера:</div>
            <textarea v-model="form.parserDefinition" rows="20"></textarea>
          </label>
        </div>

        <div class="create-feed-form-inputs mb-35">
          <label class="input-block">
            <div class="input-block--text">Содержит контент 18+:</div>
            <input type="checkbox" v-model="form.isAdult">
          </label>
        </div>
      </div>
      <div class="create-feed-form--col-right">
        <SingleTextareaFilter caption="Страны" v-model="form.countryFilterList" />
        <SingleTextareaFilter caption="Площадки" v-model="form.siteFilterList" />
        <SingleTextareaFilter caption="Пользователи" v-model="form.userFilterList" />
        <SingleListFilter caption="Браузеры" v-model="form.browserFilterList" :options="browsers" />

        <div class="create-feed-form-inputs mb-35">
          <label class="input-block">
            <div class="input-block--text">Разрешить IPv6:</div>
            <input type="checkbox" v-model="form.allowIPv6">
          </label>
        </div>
        <div class="create-feed-form-inputs mb-35">
          <label class="input-block">
            <div class="input-block--text">Разрешить второй аукцион:</div>
            <input type="checkbox" v-model="form.allowSecondAuction">
          </label>
        </div>
      </div>
    </div>
    <div class="create-feed-form-inputs mb-35">
      <label class="input-block">
        <div class="input-block--text">Дискреп по странам:</div>
        <country-discrep v-model="form.countryDiscrep" />
      </label>
    </div>
    <div class="create-feed-form-inputs mb-35">
      <label class="input-block">
        <div class="input-block--text">Мин. цена продажи трафика:</div>
        <price-limits v-model="form.minPrices" />
      </label>
    </div>
    <div class="input-block mb-25">
      <div class="input-block--text">Endpoint:</div>
      <textarea ref="endpointField" v-model.trim="form.endpoint" rows="5" />
    </div>
    <div class="input-block mb-25">
      <div class="input-block--text">Заметка:</div>
      <textarea v-model.trim="form.note" />
    </div>
    <div class="create-feed-form--info mb-30">
      <div :key="variable.name" v-for="variable in variables" class="create-feed-form--info-item" @click="insertKey(variable.key)">
        <div class="create-feed-form--info-key">{{ variable.key }}</div>
        <div class="create-feed-form--info-val">{{ variable.description }} (e.g. {{ variable.example }})</div>
      </div>
    </div>
    <button :disabled="!formValid" class="btn btn-blue create-feed-form--submit" type="submit">{{ buttonText }}</button>
  </form>
</template>

<script>
import BlackWhiteFilters from '@/components/BlackWhiteFilters.vue';
import CountryDiscrep from '@/components/CountryDiscrep';
import PriceLimits from '@/components/PriceLimits.vue';
import RadioChoice from '@/components/RadioChoice';
import SingleListFilter from '@/components/SingleListFilter.vue';
import SingleTextareaFilter from '@/components/SingleTextareaFilter.vue';
import { copyMixin } from '@/mixins/copyMixin';
import { setCaretPosition } from '@/mixins/setCaretPosition';

function isValidHttpUrl(string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
}

function filterList(list) {
  return list.filter(v => v.length > 0);
}

export default {
  name: 'Feed',
  components: {
    SingleTextareaFilter,
    SingleListFilter,
    BlackWhiteFilters,
    PriceLimits,
    RadioChoice,
    CountryDiscrep,
  },
  mixins: [copyMixin, setCaretPosition],
  data: function() {
    return {
      form: {
        name: '',
        status: true,
        allowTrafficCategory: 3,
        proxyTrafficFilter: 'allowAll',
        deviceTypeFilter: 'allowAll',
        type: 'push',
        token: '',
        parser: '',
        parserDefinition: null,
        rps: 0,
        discrep: 0,
        countryDiscrep: {},
        minPrices: {
          type: 'none',
          custom: {},
        },
        endpoint: 'https://example.com',
        isAdult: false,
        countryFilterList: {
          color: 'White',
          items: [],
        },
        siteFilterList: {
          color: 'White',
          items: [],
        },
        userFilterList: {
          color: 'White',
          items: [],
        },
        browserFilterList: {
          color: 'White',
          items: [],
        },
        allowIPv6: true,
        allowSecondAuction: false,
      },
      statuses: [
        {
          code: false,
          label: 'Отключен',
        },
        {
          code: true,
          label: 'Активный',
        },
      ],
      trafficCategories: [
        {
          value: 3,
          label: 'Без ограничений',
        },
        {
          value: 1,
          label: 'Mainstream',
        },
        {
          value: 2,
          label: 'Adult',
        },
      ],
      proxyTrafficFilterValues: [
        {
          value: 'allowAll',
          label: 'Без ограничений',
        },
        {
          value: 'denyProxy',
          label: 'Запретить прокси',
        },
        {
          value: 'onlyProxy',
          label: 'Только прокси',
        },
      ],
      deviceTypeFilterValues: [
        {
          value: 'allowAll',
          label: 'Без ограничений',
        },
        {
          value: 'onlyMobile',
          label: 'Только мобильный трафик',
        },
        {
          value: 'onlyDesktop',
          label: 'Только десктоп трафик',
        },
      ],
      browsers: [],
      types: [],
      variables: [],
      parsers: [],
    };
  },
  computed: {
    id() {
      return parseInt(this.$route.params.id, 10);
    },
    isEdit() {
      return this.id > 0;
    },
    buttonText() {
      return this.isEdit ? 'Сохранить' : 'Создать';
    },
    formValid() {
      return this.form.name.length > 0
          && this.form.parser.length > 0
          && (this.form.discrep >= 0 && this.form.discrep <= 100)
          && isValidHttpUrl(this.form.endpoint)
          && this.form.rps >= 0;
    },
  },
  async created() {
    if (this.isEdit) {
      this.$api.getFeed(this.id).then(feed => {
        this.form = this.feedToForm(feed);
      }).catch(e => {
        this.$notification.error(e.status === 404 ? 'Фид с таким ИД не существует' : 'Ошибка загрузки фида');
      });
    }

    this.$api.getVariables().then(variables => {
      this.variables = variables.map(variable => ({
        ...variable,
        key: `{${variable.name}}`,
      }));
    }).catch(() => {
      this.$notification.error('Ошибка загрузки переменных');
    });

    this.$api.getTypes().then(types => {
      this.types = Object.keys(types)
                         .map(key => ({
                           name: key,
                           title: types[key],
                         }));
    }).catch(() => {
      this.$notification.error('Ошибка загрузки типов');
    });

    this.$api.getParsers().then(parsers => {
      this.parsers = parsers.map(name => ({
        label: name,
        code: name,
      }));
    }).catch(() => {
      this.$notification.error('Ошибка загрузки парсеров');
    });

    this.$api.getBrowsers().then(list => {
      this.browsers = list.map(name => ({
        value: name,
        label: name,
      }));
    }).catch(() => {
      this.$notification.error('Ошибка загрузки браузеров');
    });
  },
  methods: {
    insertKey(insert) {
      const tArea = this.$refs.endpointField;
      if (0 === insert) {
        return;
      }
      const startPos = tArea.selectionStart,
          endPos = tArea.selectionEnd,
          tmpStr = tArea.value;
      let cursorPos = startPos;

      if (0 === cursorPos) {
        return;
      }

      this.form.endpoint = tmpStr.substring(0, startPos) + insert + tmpStr.substring(endPos, tmpStr.length);

      setTimeout(() => {
        cursorPos += insert.length;
        tArea.selectionStart = tArea.selectionEnd = cursorPos;
        this.setCaretPosition(tArea, tArea.selectionStart, tArea.selectionEnd);
      }, 10);
    },
    setValue(e) {
      this.form.type = e;
    },
    feedToForm(feed) {
      return {
        name: feed.name,
        status: feed.enabled,
        allowTrafficCategory: feed.allowTrafficCategory,
        proxyTrafficFilter: feed.proxyTrafficFilter,
        deviceTypeFilter: feed.deviceTypeFilter,
        type: feed.type,
        token: feed.token,
        parser: feed.parser,
        parserDefinition: JSON.stringify(feed.parserDefinition, null, '  '),
        discrep: feed.discrep,
        countryDiscrep: feed.countryDiscrep,
        minPrices: feed.minPrices,
        rps: feed.rps,
        endpoint: feed.endpoint,
        isAdult: feed.isAdult,
        countryFilterList: feed.countryFilterList || {
          color: 'White',
          items: [],
        },
        siteFilterList: feed.siteFilterList || {
          color: 'White',
          items: [],
        },
        userFilterList: feed.userFilterList || {
          color: 'White',
          items: [],
        },
        browserFilterList: feed.browserFilterList || {
          color: 'White',
          items: [],
        },
        allowIPv6: feed.allowIPv6,
        allowSecondAuction: feed.allowSecondAuction,
        note: feed.note,
      };
    },
    formToFeed(id, form) {
      return {
        id: id,
        name: form.name,
        enabled: form.status,
        type: form.type,
        allowTrafficCategory: form.allowTrafficCategory,
        proxyTrafficFilter: form.proxyTrafficFilter,
        deviceTypeFilter: form.deviceTypeFilter,
        parser: form.parser,
        parserDefinition: form.parserDefinition ? JSON.parse(form.parserDefinition) : null,
        rps: parseInt(form.rps, 10),
        discrep: parseInt(form.discrep, 10),
        countryDiscrep: form.countryDiscrep,
        minPrices: form.minPrices,
        endpoint: form.endpoint,
        isAdult: form.isAdult,
        countryFilterList: form.countryFilterList,
        siteFilterList: form.siteFilterList,
        userFilterList: form.userFilterList,
        browserFilterList: form.browserFilterList,
        allowIPv6: form.allowIPv6,
        allowSecondAuction: form.allowSecondAuction,
        note: form.note,
      };
    },
    async save() {
      try {
        this.$globalSpinner.show();

        const {
          id,
          check,
        } = await this.$api.saveFeed(this.formToFeed(this.id, this.form));
        this.$notification.info('Фид сохранен');
        if (check) {
          console.log('check', check);
          if (check.errorMessage) {
            console.log('errorMessage', check.errorMessage);
            this.$notification.error(`Не удалось проверить фид: ${check.errorMessage}`, { closeOnClick: false });
          } else {
            this.$notification.info('Фид успешно проверен');
          }
        }
        if (!this.isEdit) {
          this.$router.push({
            name: 'FeedId',
            params: { id: id },
          });
        }
      } catch (e) {
        this.$notification.error('Ошибка сохранения фида');
        const fields = (e.data ? e.data.fields : []) || [];
        Object.keys(fields).forEach(field => {
          this.$notification.error(`${field}: ${fields[field]}`);
        });
      } finally {
        this.$globalSpinner.hide();
      }
    },
  },
};
</script>
